import { motion } from 'framer-motion';

const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-hand-heart-line',
      title: '身体介護',
      description: '食事・入浴・排泄などの日常生活動作のサポート。お客様の尊厳を大切にしながら、安全で快適な介護を提供します。',
      image: 'https://public.readdy.ai/ai/img_res/ab155b52e784cef5b52e27e4d03e905f.jpg',
      details: ['食事介助', '入浴介助', '排泄介助', '更衣介助', '体位変換', '移乗・移動介助'],
    },
    {
      icon: 'ri-home-heart-line',
      title: '生活援助',
      description: '掃除・洗濯・調理などの家事全般をサポート。ご自宅での快適な生活環境を維持します。',
      image: 'https://readdy.ai/api/search-image?query=japanese%20caregiver%20helping%20with%20household%20tasks%20cleaning%20cooking%20warm%20home%20environment%20natural%20lighting%20simple%20clean%20background%20daily%20life%20support&width=800&height=600&seq=service-2&orientation=landscape',
      details: ['掃除・整理整頓', '洗濯', '調理・配膳', '買い物代行', 'ゴミ出し', '薬の受け取り'],
    },
    {
      icon: 'ri-stethoscope-line',
      title: '通院介助',
      description: '病院への付き添いや受診手続きのサポート。安心して医療機関を受診できるようお手伝いします。',
      image: 'https://readdy.ai/api/search-image?query=japanese%20caregiver%20accompanying%20elderly%20person%20to%20hospital%20supportive%20caring%20atmosphere%20outdoor%20walking%20simple%20background%20healthcare%20assistance&width=800&height=600&seq=service-3&orientation=landscape',
      details: ['通院の付き添い', '受診手続き', '薬の受け取り', '医師との連絡調整', '移動介助', '待ち時間のサポート'],
    },
    {
      icon: 'ri-calendar-check-line',
      title: '服薬管理',
      description: 'お薬の管理や服薬の確認をサポート。正しい服薬で健康維持をお手伝いします。',
      image: 'https://readdy.ai/api/search-image?query=japanese%20caregiver%20helping%20elderly%20person%20with%20medication%20management%20caring%20professional%20setting%20natural%20indoor%20light%20simple%20clean%20background%20healthcare&width=800&height=600&seq=service-4&orientation=landscape',
      details: ['服薬の声かけ', '薬のセット', '服薬確認', '薬の保管管理', '処方箋の管理', '医師への報告'],
    },
    {
      icon: 'ri-walk-line',
      title: 'リハビリ補助',
      description: '日常生活動作の維持・向上を目指したリハビリのサポート。専門知識を持ったスタッフが対応します。',
      image: 'https://readdy.ai/api/search-image?query=japanese%20caregiver%20assisting%20elderly%20person%20with%20gentle%20rehabilitation%20exercises%20supportive%20atmosphere%20indoor%20setting%20simple%20background%20healthcare%20therapy&width=800&height=600&seq=service-5&orientation=landscape',
      details: ['歩行訓練', 'ストレッチ', '関節可動域訓練', '筋力維持運動', '日常動作訓練', '転倒予防'],
    },
    {
      icon: 'ri-chat-heart-line',
      title: '見守り・話し相手',
      description: '孤独感の解消や精神的なサポート。心の健康も大切にしたケアを提供します。',
      image: 'https://readdy.ai/api/search-image?query=japanese%20caregiver%20having%20warm%20conversation%20with%20elderly%20person%20smiling%20friendly%20atmosphere%20natural%20indoor%20lighting%20simple%20background%20companionship&width=800&height=600&seq=service-6&orientation=landscape',
      details: ['日常会話', '傾聴', '安否確認', '趣味活動のサポート', '外出同行', '季節行事の参加'],
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-3 sm:mb-4 px-4">
            提供サービス
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-navy-700 max-w-2xl mx-auto px-4">
            岡山市北区で充実した訪問介護サービスを提供しています
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-beige-50 rounded-2xl overflow-hidden hover:shadow-lg transition-shadow"
            >
              <div className="w-full h-48 sm:h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6 sm:p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-coral-500 rounded-full mr-4 flex-shrink-0">
                    <i className={`${service.icon} text-xl sm:text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-navy-800">
                    {service.title}
                  </h3>
                </div>
                <p className="text-sm sm:text-base text-navy-700 mb-4 sm:mb-6 leading-relaxed">
                  {service.description}
                </p>
                <div className="space-y-2">
                  <h4 className="text-sm sm:text-base font-bold text-navy-800 mb-3">
                    主なサービス内容
                  </h4>
                  <div className="grid grid-cols-2 gap-2">
                    {service.details.map((detail, idx) => (
                      <div key={idx} className="flex items-start">
                        <i className="ri-check-line text-coral-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span className="text-xs sm:text-sm text-navy-700 break-words">
                          {detail}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
